import { withDataVersion } from '@hakimo-ui/hakimo/util';
import { DataVersion, ViewAlarmPayload } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useViewLocationAlarm(
  onSuccess?: (data: null, variables: ViewAlarmPayload) => void,
  dataVersion?: DataVersion
) {
  const url = `/v2/orm/location_alarms/view`;

  const request = new Request(url, {
    method: 'POST',
  });
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<null, ViewAlarmPayload>(request, {
    onSuccessInvalidationKeys: [
      ['locationAlarms'],
      ['location_alarm_updates'],
      ['alarm_groups'],
    ],
    onSuccess,
    getBody: (payload: ViewAlarmPayload) => {
      if ('product' in payload && payload.product === 'scan') {
        return JSON.stringify({
          alarmGroupId: payload.alarmGroupId,
          product: payload.product,
        });
      }
      return JSON.stringify({
        alarmId: (payload as { alarmId: string }).alarmId,
      });
    },
  });
}

export default useViewLocationAlarm;
